/* Fleur & Mae custom mega menus — populated with REAL product data */
(function () {

  // ==========================================================================
  // Live countdown for next day delivery (3pm cutoff)
  // ==========================================================================
  function updateCountdowns() {
    var els = document.querySelectorAll('[data-fm-countdown]');
    if (!els.length) return;
    var now = new Date();
    var cutoff = new Date();
    cutoff.setHours(15, 0, 0, 0);
    if (now >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
    var diff = cutoff - now;
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    var pad = function (n) { return n < 10 ? '0' + n : n; };
    var text = pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
    els.forEach(function (el) { el.textContent = text; });
  }

  // ==========================================================================
  // REAL product data per collection (sourced from Shopify Admin API)
  // Each entry: { label, url } — no fake sub-category links here
  // ==========================================================================
  var data = {
    plants: {
      collection: '/collections/artificial-plants',
      sizes: [
        { label: 'Tabletop', sub: 'up to 50cm', url: '/collections/artificial-plants?filter.v.price.gte=0&filter.v.price.lte=8000' },
        { label: 'Floor', sub: '50–100cm', url: '/collections/artificial-plants?filter.v.price.gte=8000&filter.v.price.lte=20000' },
        { label: 'Statement', sub: '100cm +', url: '/collections/artificial-plants?filter.v.price.gte=20000' }
      ],
      products: [
        { label: 'Aloe Vera Plant', url: '/products/aloe-vera-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0273-scaled.jpg?v=1774973694&width=80' },
        { label: 'Canna Lily', url: '/products/canna-lilly', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0921-scaled.jpg?v=1774973696&width=80' },
        { label: 'Colocasia Esculenta', url: '/products/colocasia-esculenta', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/820-14-3-scaled.jpg?v=1774973701&width=80' },
        { label: 'Cymbidium Orchid 140CM', url: '/products/cymbidium-orchid', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0924-scaled.jpg?v=1774973706&width=80' },
        { label: 'Dandelion Plant', url: '/products/dandelion-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0881-scaled.jpg?v=1774973709&width=80' },
        { label: 'Dandelion Plant (Tall)', url: '/products/dandelion-plant-2', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0239-scaled.jpg?v=1774973775&width=80' },
        { label: 'Dracaena Fragrans', url: '/products/dracaena-fragrans', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0159-scaled.jpg?v=1774973718&width=80' },
        { label: 'Dwarf Cymbidium Plant', url: '/products/dwarf-cymbidium-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0120-scaled.jpg?v=1774973718&width=80' },
        { label: 'Eucalyptus Leaf', url: '/products/eucalyptus-leaf', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0273-2-scaled.jpg?v=1774973721&width=80' },
        { label: 'Ficus Plant 75CM', url: '/products/ficus-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_1023-scaled_8724758d-3152-4ca8-977f-e5c1c74be371.jpg?v=1774973724&width=80' },
        { label: 'Green Stem Bamboo Plant', url: '/products/green-stem-bamboo-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0928-scaled_78037f88-24d6-4277-9c24-6fac54008c23.jpg?v=1774973736&width=80' },
        { label: 'Japanese Bamboo Plant', url: '/products/japanese-bamboo-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Bamboo-145cm-347E-748-6-scaled.jpg?v=1774973747&width=80' },
        { label: 'Monstera Swiss Cheese Plant', url: '/products/monstera-swiss-cheese-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0965-scaled.jpg?v=1774973750&width=80' },
        { label: 'Narcissus', url: '/products/narcissus', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0892-Copy-scaled.jpg?v=1774973752&width=80' },
        { label: 'Nolina Recurvarta', url: '/products/nolina-recurvarta', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0295.jpg?v=1776777184&width=80' },
        { label: 'Pineapple Plant', url: '/products/pineapple-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0456-scaled.jpg?v=1774973764&width=80' },
        { label: 'Pompon Plant', url: '/products/pompon-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0295-scaled.jpg?v=1774973768&width=80' },
        { label: 'Red Amaryllis Plant 100CM', url: '/products/red-amaryllis-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/920-28-2-3-1-scaled.jpg?v=1774973772&width=80' },
        { label: 'Schefflera Arboricola 114CM', url: '/products/schefflera-arboricola', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0106-scaled.jpg?v=1774973774&width=80' },
        { label: 'White Amaryllis Plant 80CM', url: '/products/white-amaryllis-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0429-scaled.jpg?v=1774973784&width=80' }
      ],
      featuredProduct: { name: 'Monstera Swiss Cheese', price: 'View Product', url: '/products/monstera-swiss-cheese-plant', badge: 'Customer Favourite' },
      tag: 'Curated Plants',
      title: 'Artificial Plants',
      desc: 'Lifelike plants for every space — from tabletop accents to statement pieces.',
      image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/fm-col-plants.jpg',
      buttonLabel: 'Shop All 20 Plants',
      buttonLink: '/collections/artificial-plants'
    },
    trees: {
      collection: '/collections/artificial-trees',
      sizes: [
        { label: 'Small', sub: 'up to 100cm', url: '/collections/artificial-trees?filter.v.price.gte=0&filter.v.price.lte=15000' },
        { label: 'Medium', sub: '100–180cm', url: '/collections/artificial-trees?filter.v.price.gte=15000&filter.v.price.lte=30000' },
        { label: 'Large', sub: '180cm +', url: '/collections/artificial-trees?filter.v.price.gte=30000' }
      ],
      products: [
        { label: 'Areca Palm Tree', url: '/products/areca-palm-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0007-scaled.jpg?v=1774973694&width=80' },
        { label: 'Coco Palm Tree', url: '/products/coco-palm-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Coco-Palm-Tree-360cm-831-15.jpg?v=1774973699&width=80' },
        { label: 'Grand Tuscan Olive Tree 142CM', url: '/products/grand-tuscan-olive-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Olive-Tree-142cm-916-1092-78.jpg?v=1774973730&width=80' },
        { label: 'Hawaii Palm Tree 155CM', url: '/products/hawaii-palm-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_1619-scaled.jpg?v=1774973740&width=80' },
        { label: 'Hawaii Palm Tree 165CM', url: '/products/hawaii-palm-tree-2', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0015-scaled.jpg?v=1774973783&width=80' },
        { label: 'Oak Tree', url: '/products/oak-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_1028-scaled.jpg?v=1774973755&width=80' },
        { label: 'Olive Tree 114CM', url: '/products/olive-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Olive-Tree-108cm-916-840-60-scaled.jpg?v=1774973757&width=80' },
        { label: 'Paradise Palm Tree', url: '/products/paradise-palm-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Paradise-Palm-Tree-200cm-926-15N-scaled.jpg?v=1774973760&width=80' },
        { label: 'Petite Mediterranean Olive Tree 80CM', url: '/products/petite-mediterranean-olive-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0575-scaled.jpg?v=1774973762&width=80' },
        { label: 'Sunset Palm Tree 225CM', url: '/products/sunset-palm-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Areca-Palm-Tree-225cm-926-23-6-scaled.jpg?v=1774973780&width=80' },
        { label: 'Tall Stem Dracaena Fragrans', url: '/products/tall-stem-draceana-fragrans', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0047-scaled.jpg?v=1774973781&width=80' }
      ],
      featuredProduct: { name: 'Grand Tuscan Olive Tree', price: '142CM', url: '/products/grand-tuscan-olive-tree', badge: 'Bestseller' },
      tag: 'Statement Trees',
      title: 'Artificial Trees',
      desc: 'Transform any space with magnificent, handcrafted trees.',
      image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/fm-col-trees.jpg',
      buttonLabel: 'Shop All 11 Trees',
      buttonLink: '/collections/artificial-trees'
    },
    grass: {
      collection: '/collections/artificial-grass',
      sizes: [
        { label: 'Short Grasses', sub: 'compact texture', url: '/collections/artificial-grass?filter.v.price.gte=0&filter.v.price.lte=6000' },
        { label: 'Tall Grasses', sub: 'feature pieces', url: '/collections/artificial-grass?filter.v.price.gte=6000' }
      ],
      products: [
        { label: 'Allium Grass', url: '/products/allium-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0428-1-scaled.jpg?v=1774973689&width=80' },
        { label: 'Bellflower Grass', url: '/products/bellflower-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0282-scaled.jpg?v=1774973696&width=80' },
        { label: 'Cattail Grass', url: '/products/cattail-beige-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0370-scaled.jpg?v=1774973697&width=80' },
        { label: 'Curly Green Grass', url: '/products/curly-green-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Curly-Grass-Green-183cm-7202-TBG-scaled.jpg?v=1774973703&width=80' },
        { label: 'Cycas Grass', url: '/products/cycas-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/unnamed-1-1.jpg?v=1774973705&width=80' },
        { label: 'Dancing Orchid Grass', url: '/products/dancing-orchid-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0786-scaled.jpg?v=1774973708&width=80' },
        { label: 'Dried Pampas Grass', url: '/products/dried-pampas-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Showroom_Plant_Images-24_1.jpg?v=1777288912&width=80' },
        { label: 'Eremurus Grass', url: '/products/eremurus-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Eremurus-Grass-Yellow-White-80cm-7305-WH-PBG-scaled.jpg?v=1774973720&width=80' },
        { label: 'Flower Grass', url: '/products/flower-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0445-scaled.jpg?v=1774973726&width=80' },
        { label: 'Grain Grass', url: '/products/grain-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Grain-Grass-Brown-Yellow-122cm-7008-CF-PCF-1-scaled.jpg?v=1774973728&width=80' },
        { label: 'Grass Green/Brown', url: '/products/grass-green-brown', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Grass-Green-Brown-183cm-7331-HRG1-scaled.jpg?v=1774973732&width=80' },
        { label: 'Horsetail Grass', url: '/products/horsetail-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0381-scaled.jpg?v=1774973743&width=80' },
        { label: 'Leek Flower Grass', url: '/products/leek-flower-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0347-scaled.jpg?v=1774973748&width=80' },
        { label: 'Ornamental Grass', url: '/products/ornamental-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0310.jpg?v=1776853402&width=80' },
        { label: 'Plume Grass', url: '/products/plume-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0069-scaled.jpg?v=1774973766&width=80' },
        { label: 'Princess Flower Grass', url: '/products/princess-flower-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Princess-Flower-Grass-White-91cm-7173-WG-PBG3-scaled.jpg?v=1774973769&width=80' },
        { label: 'Sunny Grass', url: '/products/sunny-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0740-scaled.jpg?v=1774973777&width=80' },
        { label: 'Wild Grass Greenish', url: '/products/wild-grass-greenish', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0717.jpg?v=1776857766&width=80' }
      ],
      featuredProduct: { name: 'Dried Pampas Grass', price: 'Customer Favourite', url: '/products/dried-pampas-grass', badge: 'Trending' },
      tag: 'Natural Texture',
      title: 'Grass & Hedging',
      desc: 'From delicate ornamental grasses to dense hedging — texture for every space.',
      image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/fm-col-grass.jpg',
      buttonLabel: 'Shop All 18 Grasses',
      buttonLink: '/collections/artificial-grass'
    }
  };

  // Best Sellers + New Arrivals collections are empty — fall back to curated picks
  data.bestsellers = {
    collection: '/collections/best-seller',
    products: [
      { label: 'Dried Pampas Grass', url: '/products/dried-pampas-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Showroom_Plant_Images-24_1.jpg?v=1777288912&width=80' },
      { label: 'Princess Flower Grass', url: '/products/princess-flower-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Princess-Flower-Grass-White-91cm-7173-WG-PBG3-scaled.jpg?v=1774973769&width=80' },
      { label: 'Grand Tuscan Olive Tree', url: '/products/grand-tuscan-olive-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Olive-Tree-142cm-916-1092-78.jpg?v=1774973730&width=80' },
      { label: 'Monstera Swiss Cheese Plant', url: '/products/monstera-swiss-cheese-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0965-scaled.jpg?v=1774973750&width=80' },
      { label: 'Hawaii Palm Tree', url: '/products/hawaii-palm-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_1619-scaled.jpg?v=1774973740&width=80' },
      { label: 'Dwarf Cymbidium Plant', url: '/products/dwarf-cymbidium-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0120-scaled.jpg?v=1774973718&width=80' },
      { label: 'Sunset Palm Tree 225CM', url: '/products/sunset-palm-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Areca-Palm-Tree-225cm-926-23-6-scaled.jpg?v=1774973780&width=80' },
      { label: 'Allium Grass', url: '/products/allium-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0428-1-scaled.jpg?v=1774973689&width=80' }
    ],
    featuredProduct: { name: 'Dried Pampas Grass', price: 'Most Loved', url: '/products/dried-pampas-grass', badge: '#1' },
    tag: 'Customer Favourites',
    title: 'Best Sellers',
    desc: 'Our most-loved botanicals — rated 4.9/5 across thousands of orders.',
    image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/fm-col-bestsellers.jpg',
    buttonLabel: 'Browse All Bestsellers',
    buttonLink: '/collections/best-seller'
  };

  data.newarrivals = {
    collection: '/collections/new-arrivals',
    products: [
      { label: 'Sunset Palm Tree 225CM', url: '/products/sunset-palm-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/Areca-Palm-Tree-225cm-926-23-6-scaled.jpg?v=1774973780&width=80' },
      { label: 'Hawaii Palm Tree 165CM', url: '/products/hawaii-palm-tree-2', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0015-scaled.jpg?v=1774973783&width=80' },
      { label: 'Petite Mediterranean Olive Tree', url: '/products/petite-mediterranean-olive-tree', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0575-scaled.jpg?v=1774973762&width=80' },
      { label: 'Cattail Grass', url: '/products/cattail-beige-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0370-scaled.jpg?v=1774973697&width=80' },
      { label: 'Dancing Orchid Grass', url: '/products/dancing-orchid-grass', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0786-scaled.jpg?v=1774973708&width=80' },
      { label: 'Pineapple Plant', url: '/products/pineapple-plant', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0456-scaled.jpg?v=1774973764&width=80' },
      { label: 'Cymbidium Orchid 140CM', url: '/products/cymbidium-orchid', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0924-scaled.jpg?v=1774973706&width=80' },
      { label: 'Schefflera Arboricola', url: '/products/schefflera-arboricola', image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/DSC_0106-scaled.jpg?v=1774973774&width=80' }
    ],
    featuredProduct: { name: 'Sunset Palm Tree', price: '225CM', url: '/products/sunset-palm-tree', badge: 'New In' },
    tag: 'Just Landed',
    title: 'New Arrivals',
    desc: 'Fresh additions to our curated botanical collection.',
    image: 'https://cdn.shopify.com/s/files/1/1005/5542/4079/files/fm-col-styling.jpg',
    buttonLabel: 'Browse New Arrivals',
    buttonLink: '/collections/new-arrivals'
  };

  // ==========================================================================
  // LIVE DATA OVERRIDE
  // If `window.fmMegaMenuLive` was injected by the snippet `fm-mega-menu-data`
  // (renders from real Shopify collection objects), prefer that for products.
  // Hardcoded data above remains as a fallback for layout copy / featured /
  // sizes / images that aren't easily derived from collections.
  // ==========================================================================
  try {
    if (typeof window !== 'undefined' && window.fmMegaMenuLive) {
      var live = window.fmMegaMenuLive;
      Object.keys(data).forEach(function (key) {
        if (live[key] && live[key].products && live[key].products.length) {
          // Merge: replace product list with live, keep other fields (sizes, featured, copy)
          data[key].products = live[key].products.map(function (p) {
            return { label: p.label || p.title, url: p.url, image: p.image };
          });
          // Update CTA label with live count if different
          if (live[key].total && data[key].buttonLabel) {
            var noun = key === 'plants' ? 'Plants'
              : key === 'trees' ? 'Trees'
              : key === 'grass' ? 'Grasses'
              : key === 'bestsellers' ? 'Bestsellers'
              : 'Items';
            data[key].buttonLabel = 'Shop All ' + live[key].total + ' ' + noun;
          }
        }
      });
    }
  } catch (e) { /* fall back silently to hardcoded data */ }

  // Map nav-item title (from Shopify menu) → data key
  var titleMap = {
    'Plants': 'plants',
    'Artificial Plants': 'plants',
    'Trees': 'trees',
    'Artificial Trees': 'trees',
    'Grass & Hedging': 'grass',
    'Grass and Hedging': 'grass',
    'Artificial Grass': 'grass',
    'Best Sellers': 'bestsellers',
    'Bestsellers': 'bestsellers',
    'New Arrivals': 'newarrivals',
    'New In': 'newarrivals'
  };

  // ==========================================================================
  // Builders
  // ==========================================================================
  var icons = {
    star: '<svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
    truck: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M15 18H9"/><path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14"/><circle cx="17" cy="18" r="2"/><circle cx="7" cy="18" r="2"/></svg>',
    starFill: '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>',
    refresh: '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/></svg>',
    arrow: '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 5l7 7-7 7"/></svg>'
  };

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  function buildLink(p) {
    var thumb = p.image
      ? '<span class="fm-mega__link-thumb"><img src="' + p.image + '" alt="" loading="lazy" width="32" height="32"></span>'
      : '';
    return '<li><a href="' + p.url + '" class="fm-mega__link">' + thumb + '<span class="fm-mega__link-text">' + escapeHtml(p.label) + '</span></a></li>';
  }

  function buildProductColumn(d) {
    // First column = full alphabetical list of products in this collection
    // Split into 2 sub-columns if more than 12 items for readability
    var products = d.products;
    var heading = d.title;
    var headingHtml = '<a href="' + d.collection + '" class="fm-mega__heading-link"><h3 class="fm-mega__heading">' + escapeHtml(heading) + '<span class="fm-mega__col-count">' + products.length + ' products</span></h3></a>';
    if (products.length <= 12) {
      var linksHtml = products.map(buildLink).join('');
      return '<div class="fm-mega__col fm-mega__col--products">' + headingHtml + '<ul class="fm-mega__list">' + linksHtml + '</ul></div>';
    }
    // Two sub-columns for long lists
    var half = Math.ceil(products.length / 2);
    var col1 = products.slice(0, half).map(buildLink).join('');
    var col2 = products.slice(half).map(buildLink).join('');
    return '<div class="fm-mega__col fm-mega__col--products fm-mega__col--split">' + headingHtml + '<div class="fm-mega__list-wrap"><ul class="fm-mega__list">' + col1 + '</ul><ul class="fm-mega__list">' + col2 + '</ul></div></div>';
  }

  function buildShortcutsColumn(d) {
    // Top: Quick Links
    var links = [
      { label: 'View All ' + d.title, url: d.collection, icon: icons.arrow },
      { label: 'Best Sellers', url: '/collections/best-seller', icon: icons.star },
      { label: 'New Arrivals', url: '/collections/new-arrivals', icon: icons.refresh }
    ];
    var linksHtml = links.map(function (l) {
      return '<li><a href="' + l.url + '" class="fm-mega__link fm-mega__link--shortcut">' +
        '<span class="fm-mega__link-icon">' + l.icon + '</span>' +
        '<span class="fm-mega__link-text">' + escapeHtml(l.label) + '</span></a></li>';
    }).join('');

    // Bottom: Shop by Size (only if defined for this category)
    var sizeHtml = '';
    if (d.sizes && d.sizes.length) {
      var sizeLinks = d.sizes.map(function (s) {
        var subHtml = s.sub ? '<span class="fm-mega__link-sub">' + escapeHtml(s.sub) + '</span>' : '';
        return '<li><a href="' + s.url + '" class="fm-mega__link"><span class="fm-mega__link-text">' + escapeHtml(s.label) + subHtml + '</span></a></li>';
      }).join('');
      sizeHtml = '<h3 class="fm-mega__heading fm-mega__heading--sub">Shop by Size</h3><ul class="fm-mega__list">' + sizeLinks + '</ul>';
    }

    return '<div class="fm-mega__col fm-mega__col--shortcuts"><h3 class="fm-mega__heading">Quick Links</h3><ul class="fm-mega__list">' + linksHtml + '</ul>' + sizeHtml + '</div>';
  }

  function buildTrustBar() {
    return '<div class="fm-mega__trustbar">' +
      '<div class="fm-mega__trustbar-inner">' +
        '<div class="fm-mega__trust-item">' + icons.truck + '<span><strong>Free UK delivery</strong> on every order</span></div>' +
        '<div class="fm-mega__trust-item fm-mega__trust-item--countdown">' + icons.truck + '<span>Order in <strong data-fm-countdown>--h --m --s</strong> for next day</span></div>' +
        '<div class="fm-mega__trust-item">' + icons.starFill + '<span><strong>4.9/5</strong> from 1,000+ customers</span></div>' +
        '<div class="fm-mega__trust-item">' + icons.refresh + '<span><strong>30-day</strong> hassle-free returns</span></div>' +
      '</div>' +
      '</div>';
  }

  function buildFeature(d) {
    return '<a href="' + d.buttonLink + '" class="fm-mega__feature" style="background-image:url(' + d.image + '?width=600)">' +
      '<div class="fm-mega__feature-overlay">' +
        '<div class="fm-mega__tag">' + escapeHtml(d.tag) + '</div>' +
        '<h2 class="fm-mega__title">' + escapeHtml(d.title) + '</h2>' +
        '<p class="fm-mega__desc">' + escapeHtml(d.desc) + '</p>' +
        '<span class="fm-mega__btn">' + escapeHtml(d.buttonLabel) + ' &rarr;</span>' +
      '</div>' +
      '</a>';
  }

  function buildMega(d) {
    return buildTrustBar() +
      '<div class="fm-mega">' +
        '<div class="fm-mega__cols">' +
          buildProductColumn(d) +
          buildShortcutsColumn(d) +
        '</div>' +
        buildFeature(d) +
      '</div>';
  }

  // ==========================================================================
  // Init — build panel and ensure clickability
  // ==========================================================================
  function init() {
    var navItems = document.querySelectorAll('.main-nav > li');
    if (!navItems.length) return;

    navItems.forEach(function (li) {
      var link = li.querySelector('.main-nav__item--primary');
      if (!link) return;
      var title = link.textContent.trim();
      var key = titleMap[title];
      if (!key || !data[key]) return;
      if (li.classList.contains('fm-has-mega')) return;

      li.classList.add('fm-has-mega');

      var panel = document.createElement('div');
      panel.className = 'fm-mega-panel';
      panel.setAttribute('data-fm-mega', key);
      panel.innerHTML = buildMega(data[key]);
      li.appendChild(panel);

      // Ensure native dropdown details doesn't fight us — close it on hover-leave
      // Also: clicking any link inside panel should navigate, not be intercepted
      panel.addEventListener('click', function (evt) {
        var anchor = evt.target.closest('a');
        if (anchor && anchor.href) {
          // Stop propagation so the nav's js-toggle handler doesn't preventDefault
          evt.stopPropagation();
        }
      }, true); // capture phase, runs first

      // ---- Hover-intent: keep panel open with a 200ms grace period when the
      // cursor crosses the gap between the nav item and the panel. Without this,
      // moving the mouse down can briefly leave both elements and close the panel.
      var hideTimeout = null;
      function showPanel() {
        if (hideTimeout) { clearTimeout(hideTimeout); hideTimeout = null; }
        panel.classList.add('fm-mega-panel--open');
        li.classList.add('fm-has-mega--open');
      }
      function scheduleHide() {
        if (hideTimeout) clearTimeout(hideTimeout);
        hideTimeout = setTimeout(function () {
          panel.classList.remove('fm-mega-panel--open');
          li.classList.remove('fm-has-mega--open');
        }, 200);
      }
      li.addEventListener('mouseenter', showPanel);
      li.addEventListener('mouseleave', scheduleHide);
      panel.addEventListener('mouseenter', showPanel);
      panel.addEventListener('mouseleave', scheduleHide);

      // ---- Keyboard + screen-reader support (ADDITIVE — does not touch the
      // hover logic above). Tabbing onto the nav link opens the panel and lets
      // the user Tab through the curated links; Escape closes it and returns
      // focus to the trigger. aria-haspopup/expanded announce the submenu.
      link.setAttribute('aria-haspopup', 'true');
      link.setAttribute('aria-expanded', 'false');
      li.addEventListener('focusin', function () {
        showPanel();
        link.setAttribute('aria-expanded', 'true');
      });
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) {
          scheduleHide();
          link.setAttribute('aria-expanded', 'false');
        }
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          if (hideTimeout) { clearTimeout(hideTimeout); hideTimeout = null; }
          panel.classList.remove('fm-mega-panel--open');
          li.classList.remove('fm-has-mega--open');
          link.setAttribute('aria-expanded', 'false');
          link.focus();
        }
      });
    });

    updateCountdowns();
    setInterval(updateCountdowns, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
